"use strict"

import React from "react"
import ReactDOM from "react-dom"
import { Button } from "react-bootstrap"

export default class DraggableGraphHeader extends React.Component {
  render() {
    const { panelWidth, plot, px, py, portal } = this.props

    return ReactDOM.createPortal(
      <div
        className={"plot-key-div"}
        style={{
          position: "absolute",
          top: `${py}px`,
          left: `${px}px`,
          width: `${panelWidth}px`,
        }}
      >
        <div className={"plot-key-header"}>
          <div style={{ flex: "1" }}>
            <Button variant={"outline-primary"}>{plot && plot.title}</Button>
          </div>
          <Button variant={"outline-primary"}>
            <span className={"fa fa-minus-circle"} />
          </Button>
        </div>
      </div>,
      portal,
    )
  }
}
